/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
import { forTemplate } from 'app/common/lib/util/i18n';

import { ScreenBreakpoints } from 'app/src/components/Responsive';
import React from 'react';
import Media from 'react-media';
import { escapeReturnUrl } from 'app/gamma/src/util/url';
import DesktopPlaceholder from './desktop-placeholder';
import HeaderLink from './header-link';
import HeaderLogo from './header-logo';
import styles from './header.less';
import { RouteContextProvider } from 'app/common/components/RouteContextProvider/RouteContextProvider';
import { RouteNames } from 'app/common/router';
import printStyles from 'app/gamma/src/components/shared/print.less';

const formatPromo = forTemplate('header_promo_nav');
const formatSignUpLogin = forTemplate('header_signup_login');

const AnonymousHeader: React.FunctionComponent = () => {
  const returnUrl = escapeReturnUrl(location.href);
  const headerStyles = (routeName: RouteNames) =>
    classNames(
      styles.header,
      routeName !== RouteNames.BOARD &&
        routeName !== RouteNames.CARD &&
        styles.default,
      styles.anonymous,
      printStyles.noPrint,
    );

  return (
    <RouteContextProvider>
      {({ routeName }) => (
        <div
          className={headerStyles(routeName)}
          data-test-id={HeaderTestIds.Container}
        >
          <Media query={ScreenBreakpoints.MediumMin}>
            {(matches: boolean) =>
              matches && (
                <div className={styles.leftSection}>
                  <HeaderLink href="/" preventDefault={false}>
                    {formatPromo('home')}
                  </HeaderLink>
                  <HeaderLink href="/tour" preventDefault={false}>
                    {formatPromo('tour')}
                  </HeaderLink>
                  <HeaderLink
                    href="https://blog.trello.com"
                    preventDefault={false}
                  >
                    {formatPromo('blog')}
                  </HeaderLink>
                </div>
              )
            }
          </Media>
          <HeaderLogo preventDefault={false} />
          <div className={styles.rightSection}>
            <HeaderLink
              href={`/signup?returnUrl=${returnUrl}`}
              buttonStyle={'signUpColor'}
              preventDefault={false}
            >
              {formatSignUpLogin('sign-up')}
            </HeaderLink>
            <HeaderLink
              href={`/login?returnUrl=${returnUrl}`}
              buttonStyle={'normalColor'}
              preventDefault={false}
            >
              {formatSignUpLogin('log-in')}
            </HeaderLink>
            <DesktopPlaceholder />
          </div>
        </div>
      )}
    </RouteContextProvider>
  );
};

export default AnonymousHeader;
